import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";

interface News14ComponentState {
    activeLanguage: string | undefined;
}

@Component({
    selector: "dtm-main-page-lib-news-14",
    templateUrl: "./news-14.component.html",
    styleUrls: ["./news-14.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class News14Component {
    @Input() public set activeLanguage(value: string | undefined) {
        this.localStore.patchState({ activeLanguage: value });
    }

    protected readonly activeLanguage$ = this.localStore.selectByKey("activeLanguage");

    constructor(private readonly localStore: LocalComponentStore<News14ComponentState>) {
        localStore.setState({ activeLanguage: undefined });
    }
}
